import React, { useState, useEffect } from 'react';
import AppBarModal from '../../general/AppBarModal';
import { BtnForm } from '../../general/BotonesAccion';
import { FECHASGRADO } from './helper';
import {
	consulta,
	obtenerValores,
} from '../../../global/js/funciones';
import {
	Dialog,
	Grid,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	DialogContent,
	DialogActions
} from '@material-ui/core/';

const ModalFechaGrado = ({ modalFechaSolicitud, handleCloseModal, matricula, actualizarMensaje }) => {
	const [fechasGrado, setFechasGrado] = useState([]);
	const [fechaGrado, setFechaGrado] = useState('');

	useEffect(() => {
		obtenerValores(FECHASGRADO).then((data) => {
			setFechasGrado(data);
		});
	}, [])

	const actualizarFecha = () => {
		let data = {
			fechaGrado,
			matricula: matricula.id
		}
		consulta("api/v1.0/matricula/solicitud/fecha", data, "POST", (error, estado, resp) => {
			let title = 'Ha ocurrido un error, contacte con el administrador.';
			let icon = 'error';
			if (!error) {
				if (estado === 200) {
					icon = 'success';
					title = resp.titulo;
				} else {
					icon = 'info';
					title = resp.titulo;
				}
			}
			actualizarMensaje({ titulo: title, tipo: icon, mostrar: true, tiempo: 6000 });
			handleCloseModal();
		});
	}

	return (
		<Dialog open={modalFechaSolicitud} fullWidth={true} maxWidth='sm' onClose={handleCloseModal}>
			<AppBarModal
				titulo='¡ Modificar Fecha de grado !'
				mostrarModal={handleCloseModal}
				accion={handleCloseModal}
				titulo_accion='CERRAR'
			/>
			<DialogContent style={{ padding: 25 }} className='scroll'>
				<Grid container>
					<Grid item xs={12}>
						<FormControl className='form-control'>
							<InputLabel>Fecha de Grado</InputLabel>
							<Select
								value={fechaGrado}
								onChange={(e) => setFechaGrado(e.target.value)}
							>
								{
									fechasGrado.map((fg) => (
										<MenuItem key={fg.id} value={fg.id}> {fg.nombre} </MenuItem>
									))
								}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<BtnForm texto='Cerrar' callback={handleCloseModal} />
				<BtnForm texto='Editar' callback={actualizarFecha} />
			</DialogActions>
		</Dialog>
	);
};

export default ModalFechaGrado;
